module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Nasjonalt bålplassregister"}}')
  delete Component.options._Ctor
}
